import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { validateNoEmptyField, validateNoSquareBrackets } from '../../../../../../aumico-lib-core-fe/src/lib';

@Component({
    selector: 'complementary-report-title',
    templateUrl: './complementary-report-title.component.html',
    styleUrls: ['./complementary-report-title.component.scss'],
})
export class ComplementaryReportTitleComponent implements OnInit, OnChanges {
    @Input() placeholder: string = '';
    @Input() initialValue: string = '';
    @Input() displayLabel: boolean = false;
    @Input() formStatus: 'VALID' | 'INVALID' = 'VALID';

    @Output() valueChange = new EventEmitter<string>();
    @Output() formStatusChange = new EventEmitter<string>();

    control = new FormControl('', [Validators.required, validateNoEmptyField(), validateNoSquareBrackets()]);

    ngOnInit() {
        this.control.setValue(this.initialValue);
        if (this.formStatus === 'INVALID') {
            this.control.markAsDirty();
            this.control.markAsTouched();
            this.control.updateValueAndValidity();
        }
        this.control.valueChanges.subscribe((value) => {
            this.valueChange.emit(value ?? '');
        });


        this.control.statusChanges.subscribe((status) => {
            this.formStatusChange.emit(status);
        });
    }

    onBlur(): void {
        const trimmed = this.control.value?.trim() ?? '';
        if (trimmed !== this.control.value) {
            this.control.setValue(trimmed);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // Check if initialValue has changed and the component is already initialized
        if (changes['initialValue'] && !changes['initialValue'].firstChange) {
            // Update the form control value when initialValue changes
            this.control.setValue(changes['initialValue'].currentValue);
        }
    }
}
